<app-file-select *ngFor="let file of requiredFiles"
                 [needUploadButton]="needUploadButton"
                 [size]="size"
                 (selectedFilesChange)="onFileChanged($event, file.type)"
                 (upload)="onUpload(file.type)"
                 [isUploaded]="selectedFiles[file.type]?.isUploaded"
                 [error]="errors && errors[file.type]"
                 [label]="file.name">
</app-file-select>
